
import React from "react";
import logo from "../assets/otherimages/logobd.png"; // Logo
import carBanner from "../assets/otherimages/rentacar.png"; // Cars group image

const RentACarSection = () => {
  return (
    <section className="py-8 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        
        {/* Left Content */}
        <div className="text-center md:text-left">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0B2F6B] mb-4">
            Need a Car for Rent?
          </h2>
          <p className="text-lg md:text-xl text-gray-700 mb-8">
            We got you covered
          </p>

          {/* Logo + Name */}
          <div className="flex items-center justify-center md:justify-start gap-4">
            <img src={logo} alt="Blue Diamond Rent a Car" className="h-16" />
            <span className="text-[#0B2F6B] font-extrabold text-xl md:text-2xl leading-snug">
              BLUE DIAMOND <br /> RENT A CAR
            </span>
          </div>
        </div>

        {/* Right Image with Background */}
        <div className="relative flex justify-center">
          {/* Gradient Circle Behind Cars */}          
          {/* Cars Image */}
          <img
            src={carBanner}
            alt="Cars"
            className="relative z-10 max-w-2xl w-full object-contain drop-shadow-2xl"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default RentACarSection;
